import { Typography } from '@mui/material';
import React from 'react';
import type { Column } from 'react-table';
import { ContextMenuButton } from 'redesign';
import { WorkflowsCellProp, WorkflowsColumnDefinition } from './workflows.types';

export const getWorkflowColumnDefinition: () => Column<WorkflowsColumnDefinition>[] = () => {
  const workflowName: Column<WorkflowsColumnDefinition> = {
    Header: () => <Header>Naam</Header>,
    accessor: 'workflowName',
    Cell: NameCell,
  };

  const actions: Column<WorkflowsColumnDefinition> = {
    Header: () => <Header>Acties</Header>,
    accessor: 'actions',
    width: '150px',
    Cell: ActionCell,
  };

  return [workflowName, actions];
};

const Header = ({ children }: React.PropsWithChildren<unknown>) => (
  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
    {children}
  </Typography>
);

const NameCell = (cell: WorkflowsCellProp<'workflowName'>) => {
  return (
    <Typography variant="body1" noWrap>
      {cell.value}
    </Typography>
  );
};

const ActionCell = (cell: WorkflowsCellProp<'actions'>) => {
  const actions = cell.getRowActions(cell.value.workflowId);
  const isArchived = cell.row.original.isArchived;
  return <ContextMenuButton disabled={isArchived}>{actions}</ContextMenuButton>;
};
